module.exports = __webpack_public_path__ + "img/icon_symbol_gray.8ab1ea8a.svg";